import {
  Component,
  OnInit,
  OnDestroy,
  NgZone,
  ViewChild,
  Input,
} from "@angular/core";

import { Subscription } from "rxjs";

import { ModalDirective } from "ngx-bootstrap/modal";

import {
  AuthorizationService,
  EquipmentService,
  ModelService,
  PoweredByService,
  ClassificationService,
  PoweredBy,
  Classification,
  ToastrService,
} from "./../../../../shared/index";

@Component({
  selector: "attribute-edit",
  templateUrl: "./attribute-edit.html",
  standalone: false,
})
export class AttributeEditComponent implements OnInit, OnDestroy {
  @ViewChild("attributeModal") modal: ModalDirective;
  @Input("live") live = true;
  public classifications: Classification[] = [];
  public poweredBys: PoweredBy[] = [];

  public newClassification = "";
  public newPoweredBy = "";

  private subscriptions: Subscription[] = [];

  constructor(
    private _ngZone: NgZone,
    private _equipmentService: EquipmentService,
    private _modelService: ModelService,
    private _poweredByService: PoweredByService,
    private _classificationService: ClassificationService,
    private _toastrService: ToastrService
  ) {
    this.subscriptions.push(
      this._modelService.showAttributesChange.subscribe((info: boolean) => {
        this.modal.show();
      })
    );

    this.subscriptions.push(
      this._classificationService.classificationChange.subscribe(
        (info: Classification[]) => {
          this._ngZone.run(() => {
            this.classifications = info;
            for (const classification of this.classifications) {
              if (this.live)
                this._classificationService
                  .getUseCount(classification.Id)
                  .then((result: number) => {
                    classification.UseCount = result;
                  });
              else
                this._classificationService
                  .getUseCountStaged(classification.Id)
                  .then((result: number) => {
                    classification.UseCount = result;
                  });
            }
          });
        }
      )
    );
    this.subscriptions.push(
      this._poweredByService.poweredByChange.subscribe((info: PoweredBy[]) => {
        this._ngZone.run(() => {
          this.poweredBys = info;
          for (const poweredBy of this.poweredBys) {
            if (this.live)
              this._poweredByService
                .getUseCount(poweredBy.Id)
                .then((result: number) => {
                  poweredBy.UseCount = result;
                });
            else
              this._poweredByService
                .getUseCountStaged(poweredBy.Id)
                .then((result: number) => {
                  poweredBy.UseCount = result;
                });
          }
        });
      })
    );
  }

  public close(): void {
    this.modal.hide();
  }

  public createClassification(): void {
    if (Number(localStorage.getItem("Lock")) == 1) {
      this._toastrService.displayToastrMessage(
        "error",
        localStorage.getItem("Msg"),
        "Environment Status!"
      );
      return;
    }
    this._classificationService.create(this.newClassification);
    this.newClassification = "";
  }

  public createPoweredBy(): void {
    if (Number(localStorage.getItem("Lock")) == 1) {
      this._toastrService.displayToastrMessage(
        "error",
        localStorage.getItem("Msg"),
        "Environment Status!"
      );
      return;
    }
    this._poweredByService.create(this.newPoweredBy);
  }

  ngOnInit(): void {
    if (this.live) {
      this._poweredByService.getPoweredBys();
      this._classificationService.getClassifications();
    } else {
      this._poweredByService.getPoweredBysStaged();
      this._classificationService.getClassificationsStaged();
    }
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }
}
